import type { DeclaredFieldPayload } from '@Application/Documents/Templates/Actions/documentTemplateVersionFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class DeclaredFieldView {
	readonly uuid: string;
	readonly path: string;
	readonly label: string;
	readonly type: LabeledValueView;
	readonly isRequired: boolean;
	readonly order: number;

	constructor(payload: DeclaredFieldPayload) {
		this.uuid = payload.uuid;
		this.path = payload.path;
		this.label = payload.label;
		this.type = new LabeledValueView(payload.type);
		this.isRequired = payload.isRequired;
		this.order = payload.order;

		Object.freeze(this);
	}
}

export default DeclaredFieldView;
